import appendSpotlightTracking from '../../carousels/helpers/spotlightTracking';

export default class PreferencesTracking {
    ACTION_ADD = 'trackReminderSelect';
    ACTION_REMOVE = 'trackReminderDeSelect';
    CONTENT_TYPE_SHOW = 'show';
    CONTENT_TYPE_MOVIE = 'movie';
    MOVIE_SECTION_TITLE = 'home';

    constructor(contentData, cta) {
        this._om = window.om;
        this.cta = cta;
        this.isShow = contentData.contentType === this.CONTENT_TYPE_SHOW;
        this.showTrackingData = {
            showSeriesId: contentData['contentId'],
            showSeriesTitle: contentData['contentTitle'],
            contentBrand: contentData['contentBrand'] !== '' ? contentData['contentBrand'] : 'na',
            showGenre: contentData['contentGenre'] !== '' ? contentData['contentGenre'] : 'na',
            pageType: CBS.Registry.homepage ? 'front_door' : this.CONTENT_TYPE_SHOW,
        };
        this.movieTrackingData = {
            movieSectionTitle: this.MOVIE_SECTION_TITLE,
            movieId: contentData['contentId'],
            movieTitle: contentData['contentTitle'],
            pageType: CBS.Registry.homepage ? 'front_door' : this.CONTENT_TYPE_MOVIE,
        };
    }

    trackStateChangeAction(notifyIsOn) {
        if (this._om) {
            let trackingObj = this.isShow ? this.showTrackingData : this.movieTrackingData;
            const $spotlightCarousel = $(this.cta).closest('.spotlight-carousel');
            if ($spotlightCarousel) {
                trackingObj = appendSpotlightTracking($spotlightCarousel, trackingObj);
            }
            this._om.trackAction(notifyIsOn ? this.ACTION_ADD : this.ACTION_REMOVE, trackingObj);
        }
    }
}
